import axios from '@/api/utils/axios'

// 画像信息查看（脱敏/申请/审批）相关接口
// 说明：真实路径以服务端为准；前端先统一封装，方便后续只改这里。
const baseUrl = '/longstron/applet/schemeEco/profileView'

export async function fetchProfileViewStatus(params = {}, options = {}) {
  const bizType = params.bizType || ''
  const bizEntityId = params.bizEntityId || ''
  const targetUserId = params.targetUserId ? String(params.targetUserId) : ''
  const res = await axios.get(baseUrl + '/status', {
    params: {
      bizType,
      bizEntityId,
      // 后端是 Long 类型：空字符串会触发参数转换异常，因此为空时直接不传
      targetUserId: targetUserId ? targetUserId : undefined,
      // 后端当前实现不需要 conversationId，保留入参兼容后续扩展
      conversationId: params.conversationId || undefined,
      receiveType: params.receiveType || undefined,
      ...(options && options.silent ? { loading: true } : null)
    }
  })
  if (res?.code !== '00000') return null
  return res.model || null
}

export async function requestProfileView(payload = {}, options = {}) {
  const res = await axios.post(
    baseUrl + '/request',
    {
      bizType: payload.bizType || '',
      bizEntityId: payload.bizEntityId || '',
      targetUserId: payload.targetUserId || '',
      conversationId: payload.conversationId || '',
      reason: payload.reason || ''
    },
    { params: options && options.silent ? { loading: true } : undefined }
  )
  if (res?.code !== '00000') return null
  return res.model || null
}

export async function approveProfileViewRequest(requestId, options = {}) {
  if (!requestId) throw new Error('missing requestId')
  const res = await axios.post(
    baseUrl + '/approve',
    { requestId: String(requestId) },
    { params: options && options.silent ? { loading: true } : undefined }
  )
  if (res?.code !== '00000') return null
  return res.model || null
}

export async function rejectProfileViewRequest(requestId, options = {}) {
  if (!requestId) throw new Error('missing requestId')
  const res = await axios.post(
    baseUrl + '/reject',
    { requestId: String(requestId) },
    { params: options && options.silent ? { loading: true } : undefined }
  )
  if (res?.code !== '00000') return null
  return res.model || null
}

